import { useState, useEffect } from 'react'
import Loader from 'react-loaders'
import './Portfolio.scss'
import AnimatedLettrs from '../AnimatedLetters/AnimatedLettrs'
// import portfolioData from '../../data/portfolio.json'
import portfolioData from '../../data/portfolioArray'

type Props = {}

const Portfolio = (props: Props) => {
  const [letterClass, setLetterClass] = useState('text-animate')
  // const renderPortfolio = (portfolio: []) => {
  //   return (
  //     <div className="images-container">
  //       {portfolio.map(({ cover, title, id }) => {
  //         return (
  //           <div className="image-box" key={id}>
  //             <img src={cover} alt={title} className="portfolio-image" />
  //           </div>
  //         )
  //       })}
  //     </div>
  //   )
  // }

  useEffect(() => {
    setTimeout(() => {
      setLetterClass('text-animate-hover')
    }, 3000)
  }, [])
  return (
    <div className="container portfolio-page">
      {/* <div className="text-zone"> */}
      <h1 className="page-title">
        <AnimatedLettrs
          strArray={'Portfolio'.split('')}
          idx={15}
          letterClass={letterClass}
        />
      </h1>
      {/* V1 need to check*/}
      {/* <div>{renderPortfolio(portfolioData)}</div> */}
      {/* V2 */}
      <div className="images-container flex">
        {portfolioData.map(({ cover, title, id, description, url, code }) => (
          <div className="image-box" key={id}>
            <img
              src={cover}
              alt={title}
              className="portfolio-image"
              onClick={() => window.open(url)}
            />
            <div className="content">
              <p className="title">{title}</p>
              <h4 className="description">{description}</h4>
              <button className="btn" onClick={() => window.open(code)}>
                View Code
              </button>
            </div>
          </div>
        ))}
        {/* </div> */}
      </div>
      <Loader type="pacman" active />
    </div>
  )
}

export default Portfolio
